<template>
  <v-app class="app-main">
        <router-view :key="key" />
  </v-app>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/layouts/components/AppMain.vue